const mutations = {
  'SET_EXCEPTIONS' (state, { exceptions }) {
    state.exceptions = exceptions
  }
}
export default mutations
